package games.polyclub.website.frontend.store.sitemap

import games.polyclub.website.frontend.store.pages.RegisterPaymentProfilePage
import games.polyclub.website.frontend.store.pages.logged.*
import games.polyclub.website.frontend.store.pages.logged.inventory.InventoryPage
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import react.ComponentType

@Serializable
@SerialName("logged")
enum class LoggedSitemap(
    override val pathPart: String,
    override val icon: Icon?,
    override val title: String,
    override val parent: LoggedSitemap? = null,
    override val component: ComponentType<*>? = null,
    override vararg val tags: String,
    override val shortTitle: String = title,
    override val hidden: Boolean = false,
    override val isCustomLayout: Boolean = false,
): ISitemap {
    HOME("", Icon("fa-user-cog"), "Área do Cliente", component = UserAreaPage),
    CART("cart", Icon("fa-shopping-cart", Icon.Type.FONT_AWESOME_SOLID), "Carrinho de Compras", component = CartPage),
    PAY_ROOT("pay", null, hidden = true, title = "Pagamento"),
    PAY(":orderId", Icon("fa-money-bill", Icon.Type.FONT_AWESOME_SOLID), hidden = true, title = "Pagar", parent = PAY_ROOT, component = InvoicePage),
    REGISTER_PAYMENT_PROFILE("register-payment-profile", Icon("fa-id-card", Icon.Type.FONT_AWESOME_SOLID), "Cadastro de Perfil de Pagamento", hidden = true, component = RegisterPaymentProfilePage, isCustomLayout = true),
    MANAGE_PAYMENT_PROFILE("payment-profile", REGISTER_PAYMENT_PROFILE.icon, "Perfil de Pagamento", hidden = true, component = ChangePaymentProfilePage),
    INVENTORY("inventory", Icon("fa-boxes", Icon.Type.FONT_AWESOME_SOLID), title = "Inventário", component = InventoryPage),
    ORDERS("orders", Icon("fa-file-invoice-dollar", Icon.Type.FONT_AWESOME_SOLID), title = "Pedidos", component = InvoicesPage),
    CHANGE_PASSWORD("change-password", Icon("fa-key", Icon.Type.FONT_AWESOME_SOLID), title = "Alterar Senha", component = ChangePasswordPage),
    CHANGE_PRONOUN("change-pronoun", Icon("fa-question-circle", Icon.Type.FONT_AWESOME_SOLID), title = "Alterar Pronome", component = ChangePronounPage),
    ;

    override val rootPath get() = "user-area"
    override val pathParts = super.pathParts
    override val path = super.path
    override val children by lazy {
        entries.filter { it.parent == this }
    }

    companion object {
        val root = entries.filter { it.parent == null }
    }
}
